import { createFileRoute } from '@tanstack/react-router';
import { PublicClipPage } from '@/features/clips/public-clip-page';

export const Route = createFileRoute('/share/clip/$token')({ component: ShareClipRoute });

function ShareClipRoute() {
  const { token } = Route.useParams();
  return <PublicClipPage key={token} token={token} />;
}
